{
  const parsePage = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const wrap = doc.querySelector('.plp-ajax');
    const hasNext = wrap ? wrap.dataset.hasNext === '1' : false;
    const items = wrap ? Array.from(wrap.querySelectorAll('.plp-grid-item')) : [];
    return { items, hasNext };
  };

  const shownOrders = (grid) =>
    new Set(Array.from(grid.querySelectorAll('.plp-grid-item')).map((el) => el.style.order));

  const visibleModels = (grid) =>
    grid.querySelectorAll('.plp-grid-item:not(.is-frame-duplicate)').length;

  const bannerTiles = (grid) => grid.querySelectorAll('.plp-grid-banner').length;

  const refreshGrid = (grid) => {
    document.dispatchEvent(new CustomEvent('plp:grid:refresh', { detail: { root: grid } }));
  };

  const removeButton = (btn) => {
    const wrap = btn.closest('.plp-load-more');
    if (wrap) wrap.remove();
  };

  const gridState = new WeakMap();

  const stateOf = (btn, grid) => {
    let state = gridState.get(grid);
    if (!state) {
      state = {
        queue: [],
        nextPage: parseInt(btn.dataset.nextPage, 10) || 1,
        hasNext: true
      };
      gridState.set(grid, state);
    }
    return state;
  };

  const fillQueue = async (btn, grid, state) => {
    const seen = shownOrders(grid);
    const queued = new Set(state.queue.map((el) => el.style.order));

    let response;
    try {
      response = await fetch(btn.dataset.url + '&page=' + state.nextPage);
    } catch (error) {
      state.hasNext = false;
      return;
    }
    if (!response.ok) {
      state.hasNext = false;
      return;
    }

    const { items, hasNext } = parsePage(await response.text());
    state.nextPage += 1;
    state.hasNext = hasNext;

    items.forEach((el) => {
      const order = el.style.order;
      if (!seen.has(order) && !queued.has(order)) {
        state.queue.push(el);
        queued.add(order);
      }
    });
  };

  const fetchUntil = async (btn, grid, targetAdded) => {
    if (btn.dataset.busy === '1' || targetAdded <= 0) return;

    btn.dataset.busy = '1';
    btn.setAttribute('aria-busy', 'true');

    const state = stateOf(btn, grid);
    const startVisible = visibleModels(grid);

    while (visibleModels(grid) - startVisible < targetAdded) {
      if (!state.queue.length) {
        if (!state.hasNext) break;
        await fillQueue(btn, grid, state);
        if (!state.queue.length) {
          if (!state.hasNext) break;
          continue;
        }
      }

      grid.appendChild(state.queue.shift());
      refreshGrid(grid);
    }

    btn.dataset.busy = '0';
    btn.removeAttribute('aria-busy');

    if (!state.queue.length && !state.hasNext) removeButton(btn);
  };

  const pageSizeOf = (btn) => parseInt(btn.dataset.pageSize, 10) || 12;

  const setup = (btn) => {
    const grid = document.querySelector(btn.dataset.grid);
    if (!grid) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        fetchUntil(btn, grid, pageSizeOf(btn) - visibleModels(grid) - bannerTiles(grid));
      },
      { rootMargin: '200px 0px' }
    );

    observer.observe(grid);
  };

  const init = () => document.querySelectorAll('[data-plp-load-more]').forEach(setup);

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-plp-load-more]');
    if (!btn) return;
    event.preventDefault();

    const grid = document.querySelector(btn.dataset.grid);
    if (grid) fetchUntil(btn, grid, pageSizeOf(btn));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
